import axios from "axios";

// api cors 暗黑技法
// const userRequest = axios.create({
//   baseURL: 'https://cors-anywhere.herokuapp.com/https://api.peopleview.com.tw/'
// });

const test = axios.create({
  baseURL: 'http://10.10.10.194:6100/'
});

// api
const userRequest = axios.create({
  baseURL: "http://10.10.10.194:6110/",
  // timeout: 10000,
});

const apiRequest = axios.create({
  baseURL: "https://api.peopleview.com.tw/",
  // timeout: 10000,
});

// 神秘資料 api
const dataRequest = axios.create({
  baseURL: "https://gank.io/api",
});

// login
// export const apiUserLogin = (account, user, password) => userRequest.get(`/getToken?service_account=${account}&user_account=${user}&user_password=${password}`);
export const apiUserLogin = (data) =>
    apiRequest
    .post(`/getToken`, new URLSearchParams(data))
    .catch((error) => error);

// tool
export const getSources = (token) =>
    apiRequest.get(`/tool/getSources?token=${token}`).catch((error) => error);
export const getTags = (token) =>
    apiRequest.get(`/tool/getTags?token=${token}`).catch((error) => error);

//search
// export const getSearchData = (data) => userRequest.post(`/insight/promptlySearch`, new URLSearchParams(data)); // 即時
export const getSearchData = (data) => {
  return apiRequest
    .post(`/insight/search`, new URLSearchParams(data))
    .catch((error) => error); // 預算
};

// 神秘資料 api
export const apiGirlsData = () =>
  dataRequest
    .get("/v2/data/category/Girl/type/Girl/page/2/count/100")
    .catch((error) => error);

export const getMembers = (user) =>
  apiRequest
    .get("insight/accounts", {
      params: {
        token: user.token,
        checkSelf: user.checkSelf,
      },
    })
    .catch((error) => error);

export const getMemberByID = (user) =>
  apiRequest
    .get("insight/accounts/" + user.id + "/edit", {
      params: {
        token: user.token,
      },
    })
    .catch((error) => error);

export const createMember = (user) =>
  apiRequest
    .post(
      "insight/accounts",
      new URLSearchParams({
        token: user.token,
        account: user.account,
        password: user.password,
        roleSn: user.roleSn,
        authLevel: user.authLevel,
        name: user.name,
        email: user.email,
      })
    )
    .catch((error) => error);

export const editMember = (user) =>
  apiRequest
    .put(
      "insight/accounts/" + user.sn,
      new URLSearchParams({
        token: user.token,
        account: user.account,
        password: user.password,
        authLevel: user.authLevel,
        name: user.name,
        email: user.email,
      })
    )
    .catch((error) => error);

export const deleteMember = (user) =>
  apiRequest
    .delete("insight/accounts/" + user.sn, {
      data: new URLSearchParams({
        token: user.token,
      }),
    })
    .catch((error) => error);

export const checkMember = (user) =>
  apiRequest
    .get("insight/checkAccounts", {
      params:{
        token: user.token,
        account:user.account,
        roleSn:user.roleSn,
        sn:user.sn
      },
    })
    .catch((error) => error);
